import React from "react";
import { 
    useDispatch,
  useSelector,
} from 'react-redux';
import { useLocation, useNavigate } from 'react-router'

import Layout from "./Layout";

// Constants & Config
import { TEMPLATE, FEATURE, ROOT_CONSTANT, ROUTES } from '../../constants'
import { FEATURE_NAME } from "../../constants/common/features";

// Services
import { defineAccessible, ACCESSIBLE_ACTION } from "../../services/ability";
import { REDUX } from '../../services/util'
import { v3_vehicleReports } from "../../services/redux/actions";

const LayoutContainer = (props) => {

	const location = useLocation()
	const navigate = useNavigate()
    const dispatch = useDispatch()

	const { uroleid: userRole, porgid, uid } = useSelector(REDUX.reduxStoreWrapper('user'))
	const accountPackages = useSelector(REDUX.reduxStoreWrapper('user.accountPackages'))

	const navigateTo = pageKey => {
		navigate(ROUTES.MODULE_ROUTE[pageKey]);
        //cleanup
        // dispatch(v3_vehicleLogs.clear_event_vehicle_log_request())
        dispatch(v3_vehicleReports.clear_vehicle_utilisation_report_request())
        dispatch(v3_vehicleReports.clear_vehicle_report_fuel_analysis_by_timeframe_success())
	}

	const sidebarItems = FEATURE.FEATURE_MENU_ITEMS_COMP_LAYER(uid, userRole).filter(listItem => {

        if(userRole === TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_OPERATOR && (listItem.feature === FEATURE_NAME.USER_MANAGEMENT || listItem.feature === FEATURE_NAME.OVERALL_MANAGEMENT || listItem.feature === FEATURE_NAME.REPORT_MANAGEMENT || listItem.feature === FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD))
            return false
		else if(userRole)
			return defineAccessible(userRole, accountPackages, porgid, uid).can(ACCESSIBLE_ACTION.READ, listItem.feature)
		else
			return false
	})

	return (
		<Layout
			sidebarItems = {sidebarItems}
			selectedkeys = {location ? location.pathname : ""}
			themeColor = {ROOT_CONSTANT.THEME.THEME_COLOR}
			onClickSidebarItem = {sidebarItem => navigateTo(sidebarItem.key)}
		>
			{props.children}
		</Layout>
	);
}

export default LayoutContainer;